import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SVGIcon from '../../../../../../../assets/svg-icons/icons';
import './css/Amenities.styl';

export default class Amenity extends Component {
  render() {
    return (
      <li className="funeral-home-amenities__item">
        <SVGIcon
          className="funeral-home-amenities__svg"
          name="checkmark"
          fill="#079B56"
          size="1.5em"
        />
        <div className="funeral-home-amenities__name">{this.props.amenity}</div>
      </li>
    );
  }
}

Amenity.propTypes = {
  amenity: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Amenities/amenity.js